<template>
  <div class="d-flex bg-white py-3">
      <img class="me-auto" width="42" src="@/assets/images/failed-icon.svg" alt="">
      <div class="d-flex me-auto flex-column">
          <h5 class="fs-6 fw-bold text-dark">فشل تحديث كلمة المرور</h5>
          <span class="fs-14px text-secondary">حاول مرة اخر لاحقا او او <a href="#" class="text-primary">تواصل معنا</a></span>
      </div>
  </div>
</template>